import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Topbanner } from "./components/topbanner";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Cases } from "./components/cases";
import { NumberedParapgrahs } from "./components/numberedparagraph";
import { WhatIs } from "./components/whatis";
import { Services } from "./components/services";
import { ImageHorizontalList } from "./components/imagehorizontalist";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { VideoPlayer } from "./components/videoplayer";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Home = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Topbanner data={landingPageData.Topbanner} />
      <Header data={landingPageData.Header}>
        <Navigation />
      </Header>
      <Features data={landingPageData.Features} anchor="features"/>
      <WhatIs data={landingPageData.WhatIs} />
      <VideoPlayer />
      <Features data={landingPageData.EUDRFeatures} anchor="eudergenerator"/>
      <Cases data={landingPageData.Cases} />
      <Services data={landingPageData.Services} />
      <NumberedParapgrahs data={landingPageData.CompetitiveAdvantage} />
      <ImageHorizontalList data={landingPageData.SupportedBy} />

      {/* <Gallery data={landingPageData.Gallery} /> */}
      {/* <Testimonials data={landingPageData.Testimonials} /> */}
      {/* <Team data={landingPageData.Team} /> */}
      {/* <About data={landingPageData.About} /> */}
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default Home;
